import { computed } from 'vue';
import { AriaDisabled, TabIndex } from 'data-types-config';

/**
 * useInteractivesPseudoDisabled - Composable to manage pseudo-disabled states and accessibility.
 * Provides values, event handlers, and disabled CSS classes.
 */
export default function useInteractivesPseudoDisabled(props: {
  isDisabled?: boolean;
}) {
  const ariaDisabled = computed(() =>
    props.isDisabled ? AriaDisabled.True : AriaDisabled.False,
  );

  const tabIndexValue = computed(() =>
    props.isDisabled ? TabIndex.Disabled : TabIndex.Enabled,
  );

  const allClasses = computed(() =>
    props.isDisabled ? 'link--disabled button--disabled' : '',
  );

  const preventDisabledClick = (event: Event) => {
    if (props.isDisabled) event.preventDefault();
  };

  const preventDisabledKeydown = (event: Event) => {
    const keyboardEvent = event as KeyboardEvent;
    if (
      props.isDisabled &&
      (keyboardEvent.key === 'Enter' || keyboardEvent.key === ' ')
    ) {
      event.preventDefault();
    }
  };

  return {
    allClasses,
    ariaDisabled,
    tabIndexValue,
    preventDisabledClick,
    preventDisabledKeydown,
  };
}
